import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "invite-control text-big"
}
const _hoisted_2 = {
  class: "invite-control-fadeable",
  key: "abc"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_4 = {
  class: "invite-control-fadeable",
  key: "def"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"5px"} }, null, -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"5px"} }, null, -1)
const _hoisted_9 = { style: {"text-align":"right","display":"flex","justify-content":"flex-end"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["action"]
const _hoisted_12 = ["value"]

import UserInviteSender from "./user-invite-sender.vue";
import useInviteControlBase from "./useInviteControlBase";
import type { InviteControlApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'invite-control',
  props: {
    model: { default: null },
    showExamples: { type: Boolean, default: false }
  },
  emits: ["invite-action"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const {
  copied,
  serverSendTab,
  copyToClipboard,
  onCopyLink,
  onSendEvent,
  hasAddressBook,
  selectCodeUrl,
} = useInviteControlBase(props.model);

function emitInviteAction() {
  emit("invite-action");
}

function onDeletedEvent() {
  // Nothing to do here
}

return (_ctx: any,_cache: any) => {
  return (_ctx.model)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "invite-control-tab-transition",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_unref(serverSendTab) == true && _ctx.model.allowServerSend)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" Type in the " + _toDisplayString(_unref(hasAddressBook) ? "names or" : "") + " email addresses of " + _toDisplayString(_ctx.model.peoplePhrase) + ". If you want, you can also ", 1),
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (serverSendTab.value = false))
                    }, "send them an invitation link yourself"),
                    _createTextVNode(". ")
                  ]),
                  _createVNode(UserInviteSender, {
                    "user-tags": _ctx.model.userTags,
                    sendUrl: _ctx.model.sendUrl,
                    "show-examples": _ctx.showExamples,
                    onSendStarted: _cache[1] || (_cache[1] = ($event: any) => (_unref(onSendEvent)(emitInviteAction)))
                  }, null, 8, ["user-tags", "sendUrl", "show-examples"]),
                  _hoisted_3
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" Send this personalised link to " + _toDisplayString(_ctx.model.peoplePhrase) + ". ", 1),
                    (_ctx.model.allowServerSend)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                          _createTextVNode(" We can also "),
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (serverSendTab.value = true))
                          }, "send the link in an email for you"),
                          _createTextVNode(". ")
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_6,
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      type: "text",
                      ref: "inviteLink",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(selectCodeUrl)())),
                      class: "form-control input-lg invite-link-input selectAllOnClick",
                      id: "inviteLink",
                      style: {"cursor":"auto","max-width":"unset"},
                      readonly: "readonly",
                      value: _ctx.model.inviteUrl,
                      onCopy: _cache[4] || (_cache[4] = ($event: any) => (_unref(onCopyLink)(emitInviteAction, props.model ?? undefined))),
                      "aria-label": "Invite link"
                    }, null, 40, _hoisted_7)
                  ]),
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", {
                      style: _normalizeStyle([{"position":"relative","top":"10px","left":"-10px","float":"left"}, { opacity: _unref(copied) ? 0.8 : 0, transition: 'opacity 0.5s' }])
                    }, "Copied... ", 4),
                    _createElementVNode("button", {
                      class: "btn btn-default-copy btn-lg",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(copyToClipboard)(emitInviteAction))),
                      type: "button"
                    }, " Copy link ")
                  ])
                ]))
          ]),
          _: 1
        }),
        (_ctx.model.continueButtonUrl && _ctx.model.showContinueButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("form", {
                action: _ctx.model.continueButtonUrl,
                method: "post",
                style: {"text-align":"right"}
              }, [
                _createElementVNode("input", {
                  type: "submit",
                  style: {"display":"inline-block"},
                  value: _ctx.model.continueButtonText,
                  class: "btn btn-default btn-lg"
                }, null, 8, _hoisted_12)
              ], 8, _hoisted_11)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})